<template>
	<div class="pages" v-loading="listLoading">
		<div v-for='(item,index) in templateData.TemplateContent.Controls' :key='index'>
			<Digit v-if='item.Property.Control=="Number"' :data-val='item'></Digit>
			<Contact v-if='item.Property.Control=="Condition"' :data-val="item"></Contact>
			<Dates v-if='item.Property.Control=="Date"' :data-val="item"></Dates>
			<Version v-if='item.Property.Control=="Text"' @child-event='getTextVal' :data-val="item"></Version>
			<Money v-if='item.Property.Control=="Money"' :data-val="item"></Money>
			<Tips v-if='item.Property.Control=="Tips"' :data-val="item"></Tips>
			<File v-if='item.Property.Control=="File"' :data-val="item"></File>
			<Table v-if='item.Property.Control=="Table"' @child-event='tableOperation' :data-val='item'></Table>
			<Selector v-if='item.Property.Control=="Selector"' @child-event='getSelectorVal' :data-val='item'></Selector>
			<Textarea v-if='item.Property.Control=="Textarea"' :data-val='item'></Textarea>
			<Choose v-if='item.Property.Control=="Contact"' @child-event='clickChoose' :data-val='item'></Choose>
		</div>


		<Button class="submit-process" v-on:click='submit' v-bind:loading="formLoading" size="large" type="primary"> 提交
		</Button>
	</div>
</template>

<script>
	/**
	 * Version 为Text文本组件
	 */
	import Digit from '../components/Number.vue'
	import Contact from '../components/Contact.vue';
	import Dates from '../components/Date.vue';
	import Version from '../components/Text.vue';
	import Money from '../components/Money.vue';
	import Tips from '../components/Tips.vue';
	import File from '../components/File.vue';
	import Table from '../components/Table.vue';
	import Selector from '../components/Selector.vue';
	import Textarea from '../components/Textarea.vue';
	import Choose from '../components/Choose.vue';
	import wx from 'weixin-js-sdk'
	import stringUtils from "../assets/js/stringUtil.js";
	import {
		initWxConfig
	} from '../api/jssdk.js';
	import {
		getTemplateInfo,
		submitProcess
	} from '@/api/approval'
	import {
		getDepartmentInfo,
		getDepartmentRelationByName
	} from '@/api/department'
	import {
		getRelation,
		getUserInfo
	} from '@/api/employee'
	var isSubmit = false;

	var template = {
		TemplateContent: {
			Controls: []
		}
	};
	export default {
		components: {
			Contact,
			Dates,
			Version,
			Money,
			Tips,
			File,
			Table,
			Digit,
			Selector,
			Textarea,
			Choose
		},
		data() {
			return {
				templateData: template,
				relationList: null,
				logInfo: null,
				templateId: "",
				spNo: null,
				formLoading: false,
				flowId:null,
				listLoading: false,
			}
		},
		created() {
			initWxConfig(this);
			this.logInfo = this.getLoginUserInfo();
			this.templateId = this.$route.query.templateId;
			this.spNo = this.$route.query.spNo;
			this.getEmployeeRelation(this.logInfo.EmpNo);
			stringUtils.setAddIsShow(true);
		},
		methods: { //方法
			clickChoose: async function(dataVal, name) {
				var that=this;
				
				window.wx.invoke("selectEnterpriseContact", {
					"fromDepartmentId": 0, // 必填，表示打开的通讯录从指定的部门开始展示，-1表示自己所在部门开始, 0表示从最上层开始
					"mode": "single", // 必填，选择模式，single表示单选，multi表示多选
					"type": ["department"], // 必填，选择限制类型，指定department、user中的一个或者多个
					"selectedDepartmentIds": [], // 非必填，已选部门ID列表。用于多次选人时可重入，single模式下请勿填入多个id
					"selectedUserIds": [] // 非必填，已选用户ID列表。用于多次选人时可重入，single模式下请勿填入多个id
				}, async function(res) {
					if (res.err_msg == "selectEnterpriseContact:ok") {
						if (typeof res.result == 'string') {
							res.result = JSON.parse(res.result) //由于目前各个终端尚未完全兼容，需要开发者额外判断result类型以保证在各个终端的兼容性
						}
						var title = that.logInfo.fullName;
						var department = res.result.departmentList[0];
						dataVal.Values = [];
						dataVal.Values.push([department.id, department.name]);
						dataVal.Value = department.name;
						getDepartmentInfo(department.id).then(response => {
							var datas = [];
							var deptFullName = response.Body.FullName;
							var departFullName = response.Body.FullName;
							if(deptFullName.indexOf("非营业部") > -1||deptFullName.indexOf("风险管理部") > -1){
								that.templateData.TemplateContent.Controls.forEach(async (item) => {
									if(item.Property.Title[0].Text == "是否非营"){
										item.Value = parseInt("0");
									}
								})
							}
							if(deptFullName.indexOf("代理") > -1||deptFullName.indexOf("二级市场支援中心") > -1||deptFullName.indexOf("二级市场营运中心")> -1){
								that.templateData.TemplateContent.Controls.forEach(async (item) => {
								if(item.Property.Title[0].Text == "是否到部门负责人审批"){
										item.IsShow = true;
									}
								})
							}else{
								that.templateData.TemplateContent.Controls.forEach(async (item) => {
								if(item.Property.Title[0].Text == "是否到部门负责人审批"){
										item.IsShow = false;
									}
								})
							}
							
							if (deptFullName.indexOf("住宅行政支持组") > -1) {
								getDepartmentInfo(department.id).then(response => {
									that.templateData.TemplateContent.Controls.forEach(async (item) => {
										if (item.Property.Title[0].Text == "大区董事") {
											item.Values=await that.getDepartmentRelation(department.id,"高级大区董事",7);
											if (item.Values == null || item.Values.length <= 0) {
												//审批节点无人，跳过
												item.Values.push(that.$store.state.defaultMember);
											}
										}
										if (item.Property.Title[0].Text == "大区总经理") {
											item.Values=await that.getDepartmentRelation(department.id,"总经理",8);
											if (item.Values == null || item.Values.length <= 0) {
												//审批节点无人，跳过
												item.Values.push(that.$store.state.defaultMember);
											}
										}
										
										if (item.Property.Title[0].Text == "逐级审批使用") {
											item.Values=await that.getDepartmentRelationList(department.id,6);
											if (item.Values == null || item.Values.length <= 0) {
												//审批节点无人，跳过
												item.Values.push(that.$store.state.defaultMember);
											}
										}
									});
								});
							}
							if(deptFullName.indexOf("非营业部") > -1||deptFullName.indexOf("风险管理部") > -1){
								getDepartmentInfo(department.id).then(response => {
									that.templateData.TemplateContent.Controls.forEach(async (item) => {
										
										if (item.Property.Title[0].Text == "逐级审批使用") {
											if(deptFullName.indexOf("风险管理部") > -1){
												item.Values=await that.getDepartmentRelationList(department.id,7);
											}else{
												item.Values=await that.getDepartmentRelationList(department.id,8);
											}
											if (item.Values == null || item.Values.length <= 0) {
												//审批节点无人，跳过
												item.Values.push(that.$store.state.defaultMember);
											}
										}
									});
								});
							}else if(deptFullName.indexOf("住宅部") > -1||deptFullName.indexOf("工商铺商业运营中心") > -1){
								getDepartmentInfo(department.id).then(response => {
									that.templateData.TemplateContent.Controls.forEach(async (item) => {
										if (item.Property.Title[0].Text == "请选择审批行政助理") {
											item.Values = await that.getDepartmentRelation(department.id, "行政助理");
											if (item.Values == null || item.Values.length <= 0) {
												//审批节点无人，跳过
												item.Values.push(that.$store.state.defaultMember);
											}
										}
										
										if (item.Property.Title[0].Text == "逐级审批使用") {
											await getDepartmentRelationByName(departFullName, true).then(async response => {
												if (response.Body != null) {
													datas = response.Body[0].Nodes;
												}
											})
											item.Values = that.getRelationList(datas, 6);
											if (item.Values == null || item.Values.length <= 0) {
												//审批节点无人，跳过
												item.Values.push(that.$store.state.defaultMember);
											}
										}
										
										if (item.Property.Title[0].Text == "大区董事") {
											item.Values=await that.getDepartmentRelation(department.id,"大区董事",true);
											if (item.Values == null || item.Values.length <= 0) {
												//审批节点无人，跳过
												item.Values.push(that.$store.state.defaultMember);
											}
										}
										if (item.Property.Title[0].Text == "大区总经理") {
											
											item.Values=await that.getDepartmentRelation(department.id,"总经理",true);
											
											if (item.Values == null || item.Values.length <= 0) {
												//审批节点无人，跳过
												item.Values.push(that.$store.state.defaultMember);
											}
										}
									});
								});
							}
							
							that.templateData.TemplateContent.Controls.forEach(item =>{
								if (item.Property.Title[0].Text == "所在部门") {
									if (deptFullName.indexOf("房友圈") > -1||deptFullName.indexOf("藤云") > -1) {
										item.Value=item.Config.Selector.Options.filter(o=>{ return o.Value[0].Text == "房友圈"})[0].Key;
									} 
									else if (deptFullName.indexOf("二级市场营运中心") > -1||deptFullName.indexOf("代理")>-1) {
										item.Value=item.Config.Selector.Options.filter(o=>{ return o.Value[0].Text == "二级市场营运中心/代理"})[0].Key;
									}
									else if (deptFullName.indexOf("非营业部") > -1||deptFullName.indexOf("风险管理部") > -1) {
										item.Value=item.Config.Selector.Options.filter(o=>{ return o.Value[0].Text == "非营业部"})[0].Key;
									}  
									else if (deptFullName.indexOf("住宅部") > -1) {
										item.Value=item.Config.Selector.Options.filter(o=>{ return o.Value[0].Text == "住宅部"})[0].Key;
									}  
									else if (deptFullName.indexOf("按揭金融服务中心") > -1) {
										item.Value=item.Config.Selector.Options.filter(o=>{ return o.Value[0].Text == "汇瀚"})[0].Key;
									}
									else if (deptFullName.indexOf("工商铺商业运营中心") > -1) {
										item.Value=item.Config.Selector.Options.filter(o=>{ return o.Value[0].Text == "工商铺商业运营中心"})[0].Key;
									}
									item.Disable=true;
									item.IsShow=true;
								}
							})
							
							if(deptFullName.indexOf("按揭金融服务中心")>-1||deptFullName.indexOf("房友圈")> -1||deptFullName.indexOf("藤云")> -1||deptFullName.indexOf("代理") > -1||
								deptFullName.indexOf("二级市场支援中心") > -1||deptFullName.indexOf("二级市场营运中心")> -1){
								getDepartmentInfo(department.id).then(response => {
									that.templateData.TemplateContent.Controls.forEach(async (item) => {
										if (item.Property.Title[0].Text == "逐级审批使用") {
											item.Values=await that.getDepartmentRelationList(department.id,7);
											if (item.Values == null || item.Values.length <= 0) {
												//审批节点无人，跳过
												item.Values.push(that.$store.state.defaultMember);
											}
										}
									});
								});
							}
						})
					}
				})
			},
			getTemplate:async function() {
				var departs = this.logInfo.fullName.split("/");
				if (departs.indexOf("房友圈") == -1 &&
					departs.indexOf("工商铺商业运营中心") == -1 &&
					departs.indexOf("二级市场营运中心") == -1 &&
					departs.indexOf("住宅部") == -1 &&
					departs.indexOf("按揭金融服务中心") == -1 &&
					departs.indexOf("住宅行政支持组") == -1 &&
					departs.indexOf("非营业部") == -1 &&
					departs.indexOf("原友信/风险管理部") == -1 &&
					this.isDisabled == false
				) {
					this.Message({
						message: '没有申请权限',
						type: 'error',
						duration: 1000
					});
					this.isDisabled = true;
				}
				this.listLoading = true;
				var title = this.logInfo.fullName;
				getTemplateInfo(this.templateId).then(async response => {
					var controls = response.Body;
					console.log(controls)
					this.templateData = this.assignControl(controls, this.logInfo);
					this.templateData.TemplateContent.Controls.forEach(async (item) => {
						if(item.Property.Title[0].Text == "是否到部门负责人审批"){
							item.IsShow = false;
						}
						if(item.Property.Title[0].Text == "是否非营"){
							item.Value = parseInt("1");
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "部门 ") {
							if (departs.indexOf("华西区") > -1) {
								item.Value = departs[departs.indexOf("华西区") + 1] + "/" + this.logInfo.DeptName;
							}
							if (departs.indexOf("非营业部") > -1||departs.indexOf("风险管理部")) {
								item.Value = departs[departs.indexOf("非营业部") + 1] + "/" + this.logInfo.DeptName;
							}
							if (departs.indexOf("营业部") > -1) {
								item.Value = departs[departs.indexOf("营业部") + 1] + "/" + this.logInfo.DeptName;
							}
							if (departs.indexOf("其他") > -1) {
								item.Value = departs[departs.indexOf("其他") + 1] + "/" + this.logInfo.DeptName;
							}
						}
						
						if (item.Property.Title[0].Text == "请选择审批行政助理") {
							item.Values = [];
							item.Values.push(this.$store.state.defaultMember);
							item.Value = "默认总经理"
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "大区董事") {
							item.IsShow = false;
							item.Values=[];
							item.Values=this.findEmpByPositionName(this.relationList,"高级大区董事",7);
							if (item.Values == null || item.Values.length <= 0) {
								//审批节点无人，跳过
								item.Values.push(this.$store.state.defaultMember);
							}
							
						}
						if (item.Property.Title[0].Text == "大区总经理") {
							item.IsShow = false;
							item.Values=[];
							item.Values=this.findEmpByPositionName(this.relationList,"总经理",8);
							if (item.Values == null || item.Values.length <= 0) {
								//审批节点无人，跳过
								item.Values.push(this.$store.state.defaultMember);
							}
						}
						if (item.Property.Title[0].Text == "逐级审批使用") {
							item.Values=[];
							item.IsShow = false;
							if (departs.indexOf("非营业部") > -1||departs.indexOf("风险管理部") > -1) {
								if(departs.indexOf("风险管理部") > -1){
									item.Values=this.getRelationList(this.relationList,7);
								}else{
									item.Values=this.getRelationList(this.relationList,8);
								}
								
							}
							if (departs.indexOf("二级市场营运中心") > -1 || departs.indexOf("代理") > -1) {
								item.Values=this.getRelationList(this.relationList,8);
							}
							if (departs.indexOf("住宅部") > -1) {
								item.Values=this.getRelationList(this.relationList,6);
							}
							if (departs.indexOf("工商铺商业运营中心") > -1) {
								item.Values=this.getRelationList(this.relationList,6);
							}
							if (departs.indexOf("按揭金融服务中心") > -1) {
								item.Values=this.getRelationList(this.relationList,7);
							}
							
							if (departs.indexOf("房友圈") > -1) {
								item.Values=this.getRelationList(this.relationList,7);
							}
							if (item.Values == null || item.Values.length <= 0) {
								//审批节点无人，跳过
								item.Values.push(this.$store.state.defaultMember);
							}
						}
					});
					this.templateData = await this.assignControlBySpNo(this.templateData, this.spNo);
					this.listLoading = false;
				});
			},
			getEmployeeRelation: async function(empNo) {
				await getRelation(empNo).then(response => {
					this.relationList = response.Body[0].Nodes;
				});
			},
			getTextVal() {},
			getSelectorVal(val, name) {},
			tableOperation(val, type, datas) {
				this.tableoperation(val, type, datas, this);
			},
			submit() {
				var that = this;
				//数据校验
				if (!this.submitValidate(this.templateData.TemplateContent.Controls)) {
					return;
				}
				if (isSubmit) {
					this.Message({
						message: '已提交',
						type: 'warning',
						duration: 1000
					});
					return;
				}
				var isOk = false;
				this.templateData.TemplateContent.Controls.forEach(e =>{
					if(e.Property.Title[0].Text == '所在部门'){
						e.Config.Selector.Options.forEach(t =>{
							if(t.Key == e.Value&&t.Value[0].Text == '住宅部'){
								that.templateData.TemplateContent.Controls.forEach(control =>{
									if(control.Property.Title[0].Text == '逐级审批使用'){
										if(control.Values.length>0&&control.Values[0][0]!='SC24000029'){
											isOk = true;
										}
									}else if(control.Property.Title[0].Text == '大区董事'){
										if(control.Values.length>0&&control.Values[0][0]!='SC24000029'){
											isOk = true;
										}
									}else if(control.Property.Title[0].Text == '大区总经理'){
										if(control.Values.length>0&&control.Values[0][0]!='SC24000029'){
											isOk = true;
										}
									}
								})
							}else if(t.Key == e.Value){
								isOk = true;
							}
						})
					}
				})
				 
				if(!isOk){
					if(!confirm('当前部门没有部门负责人,点击"ok"继续提交')){
						return;
					}
				}
				
				var SummaryList = [];
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				
				var control1=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "文档标题"})[0]
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				info.SummaryInfo.push({"Text":"内容：流程编号  "+control1.Value,"Lang":"zh_CN"});
				SummaryList.push(info);
				
				var control2=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "请选择部门"})[0]
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				info.SummaryInfo.push({"Text":"申请部门："+control2.Value,"Lang":"zh_CN"});
				SummaryList.push(info);
				
				var control3=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "申请时间"})[0]
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				info.SummaryInfo.push({"Text":"申请时间："+control3.Value,"Lang":"zh_CN"});
				SummaryList.push(info);
				this.templateData.SummaryList=SummaryList;						
				
				isSubmit = true;
				this.listLoading = true;
				
				// this.templateData.TemplateContent.Controls.forEach(async (item) => {
				// 	if(item.Property.Title[0].Text == "文档全文(同时请上传文档作为附件)"){
				// 		item.Value = JSON.stringify(this.templateData);
				// 	}
				// })
				//提交
				submitProcess(this.templateId, this.logInfo.EmpNo, this.spNo, this.templateData).then(response => {
					this.Message({
						message: '申请成功',
						type: 'success',
						duration: 3 * 1000
					});
					setTimeout(() => {
						this.$router.push("/index");
					}, 3000)
				}).finally(() => {
					isSubmit = false;
					this.listLoading = false;
				});
			}
		},
		watch: {
			relationList(val, oldVal) {
				if (oldVal == null) {
					this.getTemplate();
				}
			}
		}

	}
</script>

<style scoped lang="less">
	.pages {
		padding-bottom: 14px;
	}
</style>
